import React, {  useEffect, useState} from 'react';
import { connect } from 'react-redux';
import {getAllProducts, deleteProductBySupplier, createProductSupplier, updateProductSupplier} from '../../redux/actions/Supplier/SupplierAction';
import './SupplierStyle.css';
import SupplierSimpleTable from './SupplierSimpleTable';
import SupplierViewModal from './SupplierViewModal';
import SupplierUpdateModal from './SupplierUpdateModal';
import SupplierAddProductModal from './SupplierAddProductModal';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const GetAllProductsOfSupplier = ({products, getAllProducts, deleteProductBySupplier, createProductSupplier, updateProductSupplier, history}) =>{

    const params=useParams();

    const [rows, setRows] = useState([]);
    const [show, setShow] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [currentProduct, setCurrentProduct] = useState({});

    const handleClose = () => {
        // clearStateAction();
        setShow(false);
    };
    const handleShow = (product) => {
        setShow(true);
        setCurrentProduct(product);
        console.log('set Current product->'+currentProduct);
    };

    const handleCloseUpdate = (productId, product) => {
        // clearStateAction();
        setShowUpdate(false);
        updateProductSupplier(params.supplierId,productId,product);
        // getAllProducts(1).catch((error) => console.log(error));
        setRows(products);
        
    };
    const handleShowUpdate = (product) => {
        console.log('clicked from get all');
        setShowUpdate(true);
        setCurrentProduct(product);
        console.log('set Current product->'+currentProduct);
    };

    const handleCloseAdd = (product, success) => {
        // clearStateAction();
        if(success){
            createProductSupplier(params.supplierId,product);
            console.log('from create form'+product);
            toast.success('Item added!!');
        }
        setShowAdd(false);
        setRows(products);
        //getAllProducts(1).then(()=>setRows(products)).catch((error) => console.log(error));        
    };
    const handleShowAdd = () => {
        console.log('clicked from get all');
        setShowAdd(true);
        console.log('set Current product->'+currentProduct);
    };

    useEffect(()=> {
        if (products && products.length === 0) {
            getAllProducts(params.supplierId).catch((error) => console.log(error));
        }
        else {
            console.log('products', products);
            setRows(products);
        }
    },[products]);
    
    const handleDelete = (id) => {
        console.log('from handle delete '+id);
        deleteProductBySupplier(params.supplierId,id)
            .then(() => {
                alert('Deleting the product with Id:'+id);
                getAllProducts(params.supplierId);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const columns = [
        {
            label: 'Product ID',
            field: 'productId',
        },
        {
            label: 'Product Name',
            field: 'productName',
        },
        {
            label: 'Product Description',
            field: 'productDescription',
        },
        {
            label: 'Product Quantity',
            field: 'productQuantity',
        },
        {
            label: 'Product Type',
            field: 'productType',
        },
        {
            label: 'Date',
            field: 'date',
        }
    ];

    return(
        <div className='main-product-list-page'>
            <h1 className='product-list-page-header'>Products</h1>
            <div className='add-product-button'>
                <Button className="btn btn-primary mx-2" onClick={handleShowAdd} >
                    Add Product
                </Button>
                <Button className="btn btn2 btn-primary mx-2" onClick={()=>history.go(-1)} >
                    Back
                </Button>
            </div>
            <div className='py-5 SearchPage'>
                <div className='product-table'>
                    <SupplierSimpleTable columns={columns} rows={rows} handleShow={handleShow} handleShowUpdate={handleShowUpdate} handleDelete={handleDelete} />
                    <SupplierViewModal show={show} handleClose={handleClose} data={currentProduct} />
                    <SupplierUpdateModal showUpdate={showUpdate} handleCloseUpdate={handleCloseUpdate} data={currentProduct} currentSupplierId={params.supplierId}/>
                    <SupplierAddProductModal showAdd={showAdd} handleCloseAdd={handleCloseAdd} currentSupplierId={params.supplierId}/>
                </div>
            </div>
        </div>
    );
};

GetAllProductsOfSupplier.defaultProps ={
    products: []
};

const mapStateToProps = (state) => {
    console.log(state);
    return {
        products: state.suppliers
    };
};

const mapDispatchToProps = {
    getAllProducts,
    deleteProductBySupplier,
    createProductSupplier,
    updateProductSupplier,
};

export default connect(mapStateToProps, mapDispatchToProps)(GetAllProductsOfSupplier);